var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 3.00033V7.00032C9.33337 8.4889 9.33337 9.23318 8.84787 9.52448C8.36237 9.81579 7.70564 9.46554 6.3922 8.76503L2.6422 6.76503C1.18631 5.98856 0.458374 5.60033 0.458374 5.00033C0.458374 4.40033 1.18631 4.01209 2.6422 3.23562L6.3922 1.23562C7.70564 0.535115 8.36237 0.184863 8.84787 0.476166C9.33337 0.767468 9.33337 1.51175 9.33337 3.00033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnBack);
export default __webpack_public_path__ + "static/media/btn-back.740d4d076b6b24a51e807994a59cd505.svg";
export { ForwardRef as ReactComponent };